$(document).ready(function () {


  /*Menu dropdown*/
  var ico = $('<i class="fa fa-angle-down menudrop"></i>');
  $(
    ".main-menu > li:has(.submenu) > a,.nav-menu-wrapper ul li:has(.submenu) > a"
  ).append(ico);
  $(".menudrop").on("click", function (e) {
    $(this).parent().parent().addClass("no-hover");

    $(".main-menu li,.nav-menu-wrapper ul li")
      .not($(this).parent().parent())
      .find(".submenu")
      .stop(true, true)
      .delay(200)
      .fadeOut(500);
    $(".main-menu li,.nav-menu-wrapper ul li")
      .not($(this).parent().parent())
      .removeClass("open");
    $(".main-menu li a .menudrop,.nav-menu-wrapper ul li a .menudrop")
      .not($(this))
      .removeClass("openedmenu");
    $(".main-menu li a .menudrop,.nav-menu-wrapper ul li a .menudrop")
      .not($(this))
      .addClass("closemenu");

    e.preventDefault();
    if ($(this).hasClass("openedmenu")) {
      $(this)
        .parent()
        .parent()
        .find(".submenu")
        .stop(true, true)
        .delay(200)
        .fadeOut(500);
      $(this).removeClass("openedmenu");
      $(this).addClass("closemenu");
    } else {
      $(this)
        .parent()
        .parent()
        .find(".submenu")
        .stop(true, true)
        .delay(200)
        .fadeIn(500);
      $(this).removeClass("closemenu");
      $(this).addClass("openedmenu");
    }
  });

  $(".togglebtn, .overlay").click(function () {
    $(".togglebtn, .menuoverlay, .navheader, body").toggleClass("active");
    if ($(".overlay").hasClass("active")) {
      $(".overlay").fadeIn();
      $("html").addClass("menuhidden");
    } else {
      $(".overlay").fadeOut();
      $("html").removeClass("menuhidden");
    }
  });
  if ($(window).width() >= 1120) {
    $(".nav-menu-links li.has-sub").hover(
      function () {
        $("body").addClass("menuoverlay");
        $(window).trigger("resize");
      },
      function () {
        $("body").removeClass("menuoverlay");
      }
    );
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > 130 && $(window).width() >= 300) {
      $("body").addClass("fixed-header");
    } else {
      $("body").removeClass("fixed-header");
    }
  });


  // top header slider 
  $(".topslider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
});

});